import _ from 'lodash';

export default class CustomFieldParamsData {

    static normalize(data) {
        const result = _.assign({},data);

        result.scope = _.get(data, 'scope', [gd.const.customFields.scope.TASK])

        return result
    }
}